import { render, staticRenderFns } from "./Gracias.vue?vue&type=template&id=74780263"
import script from "./Gracias.vue?vue&type=script&lang=js"
export * from "./Gracias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports